export default "__VITE_ASSET__BT_xlJ9m__"